<template>
    <div class="row px-3">
        <table class="table table-condensed table-responsive">
            <thead class="row px-2">
                <tr class="col">
                    <th class="col">Item</th>
                    <th class="col">Tamanho</th>
                    <th class="col">Tipo</th>
                    <th class="col">Modificado</th>
                    <th class="col">Ação</th>
                </tr>
            </thead>
            <tbody class="row px-2">
                <tr class="col" v-for="(item, id) in arquivos" :key="id">
                    <td class="col">
                        <div class="media" @click="openFolder(item)">
                            <!---->
                            <div class="mr-3">
                                <img
                                    v-if="item.tipo == 'image'"
                                    :src="url + item.thumb"
                                    :alt="item.nome"
                                    height="50"
                                    @click="$emit('view', item)"
                                />
                                <img
                                    v-else
                                    :src="`${url}img/files/${formatFile(
                                        item.nome
                                    )}.svg`"
                                    :alt="item.nome"
                                    height="50"
                                    @click="$emit('view', item)"
                                />
                            </div>
                            <div class="media-body">
                                {{ item.nome }}
                            </div>
                        </div>
                    </td>
                    <td class="col"></td>
                    <td class="col">
                        {{ item.tipo == "image" ? "" : "Pasta" }}
                    </td>
                    <td class="col">{{ item.time }}</td>
                    <td class="col">
                        <div class="btn-group">
                            <button
                                title="Renomear"
                                class="btn btn-light btn-sm"
                                @click="$emit('renomear', item)"
                            >
                                <i class="mdi mdi-form-textbox"></i>
                            </button>
                            <button
                                title="Deletar"
                                class="btn btn-light btn-sm"
                                @click="$emit('deletar', item)"
                            >
                                <i class="mdi mdi-delete"></i>
                            </button>
                            <!-- <button
								v-if="formatFile(item.nome) == 'zip' || formatFile(item.nome) == 'rar'"
								title="Download"
								class="btn btn-light btn-sm"
								@click="download(item.caminho, item.nome)"
							>
								<i class="mdi mdi-download"></i>
							</button>	 -->
                            <button
                                title="Baixar"
                                class="btn btn-light btn-sm"
                                @click="download(item)"
                            >
                                <i class="mdi mdi-download"></i>
                            </button>
                            <!-- <button title="Fechar" class="btn btn-light btn-sm">
								<i class="mdi mdi-window-close"></i>
							</button> -->
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
        <h4 v-if="arquivos.length == 0" class="mx-auto">Pasta vazia.</h4>
    </div>
</template>
<script>
export default {
    props: ["arquivos"],
    data() {
        return {
            url: `${window.location.protocol}//${window.location.host}/`,
        };
    },
    methods: {
        closerMenu(id) {
            var display = document.getElementById(id);
            display.style.display = "none";
        },
        popMenu(e, id) {
            e.preventDefault();
            var display = document.getElementById(id);
            display.style.position = "absolute";
            display.style.display = "block";
            display.style.left = e.layerX + "px";
            display.style.top = e.layerY + "px";
        },
        openFolder(item) {
            if (!item.is_file) {
                this.$emit("open", item);
            }
        },
        downloadFile(anexo) {
            let path = this.url + anexo.caminho + "/" + anexo.nome;
            // window.open(path, "_blank");

            var anchor = document.createElement("a");
            anchor.href = path;
            anchor.download = path;
            document.body.appendChild(anchor);
            anchor.click();
        },
        formatFile(file) {
            var ex = file.split(".");
            return ex.length == 1 ? "folder_blue_a" : ex.pop();
        },
        download(fileUrl, fileName) {
            let timerInterval;
            swal.fire({
                html: "O arquivo está sendo preparado e logo será baixado.",
                timer: 2000,
                timerProgressBar: true,
                didOpen: () => {
                    swal.showLoading();
                    const b = swal.getHtmlContainer().querySelector("b");
                    timerInterval = setInterval(() => {
                        b.textContent = swal.getTimerLeft();
                    }, 100);
                },
                willClose: () => {
                    clearInterval(timerInterval);
                },
            }).then((result) => {
                /* Read more about handling dismissals below */
                if (result.dismiss === swal.DismissReason.timer) {
                    //console.log("I was closed by the timer");
                }
            });
            var a = document.createElement("a");
            a.href = fileUrl;
            a.setAttribute("download", fileName);
            a.click();
        },
    },
};
</script>
